/*
 *  -----------------------------------------------------------------------
 *    <copyright file="information-dialog.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DialogContent } from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';
import 'date-fns';
import React from 'react';

import { CustomDialog } from '../dialog';

import './information-dialog.scss';
import { useTranslation } from '@hooks/index';

interface ActionsEmailDialog {
    text: string;
    open: boolean;

    onClose(): any;
    heading?: string;
}

const InformationDialog = ({ open, onClose, text, heading }: ActionsEmailDialog) => {
    const { t } = useTranslation();

    return (
        <CustomDialog
            className="information-modal"
            onClose={onClose}
            fullWidth
            maxWidth="sm"
            scroll="paper"
            open={open}
        >
            <DialogTitle id="add-critical-variable">
                {heading ?? t('ra:notification')}
                <FontAwesomeIcon
                    icon={['fal', 'times']}
                    className="fa-lg close-icon-cv"
                    onClick={onClose}
                    data-testid="close-dialog"
                />
            </DialogTitle>

            <DialogContent style={{ paddingLeft: 20, paddingRight: 20 }}>{text}</DialogContent>
        </CustomDialog>
    );
};

export default InformationDialog;
